// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M12 8a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm0 4a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm0-8a5 5 0 0 0-5 5v.11c0 2.64 3.11 7.71 5 10.46 1.89-2.75 5-7.83 5-10.46A5 5 0 0 0 12.11 4H12Zm0 19c-2.36-3.2-7-9.89-7-13.89a7 7 0 0 1 14 0c0 4-4.64 10.69-7 13.89Z"
    />
  </BaseIcon>
)
